import React from "react";
import { Spinner } from "@chakra-ui/react";
import { Button } from "newui/components/Button";
import type { Clarification } from "../../types/clarification.type";
import { Modal } from "newui/components/ui/Modal";

interface DeleteConfirmationModalProps {
  clarification: Clarification | null;
  isLoading: boolean;
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => Promise<void>;
}

export const DeleteConfirmationModal: React.FC<DeleteConfirmationModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  clarification,
  isLoading,
}) => {
  const handleConfirm = async () => {
    await onConfirm();
  };

  const truncateText = (text: string, maxLength: number) => {
    if (!text) {
      return "";
    }
    return text.length > maxLength ? `${text.substring(0, maxLength)}...` : text;
  };

  const FooterComponent = () => {
    return (
      <div className="flex w-full justify-between gap-2">
        <Button onClick={onClose} btntype="base" className="!w-full" disabled={isLoading}>
          Cancel
        </Button>
        <Button
          className="!w-full"
          btntype="third-danger"
          onClick={handleConfirm}
          disabled={isLoading}
        >
          {isLoading ? <Spinner size="sm" /> : "Delete"}
        </Button>
      </div>
    );
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Delete Clarification"
      description="Please confirm deletion"
      iconType="warning"
      titleColor="red.600"
      size="md"
      customFooter={<FooterComponent />}
    >
      {clarification && (
        <div className="space-y-3">
          <div>
            <span className="text-sm font-medium text-gray-700">Reference Number:</span>{" "}
            <span className="text-sm text-gray-900">{clarification.reference_number}</span>
          </div>
          <div>
            <span className="text-sm font-medium text-gray-700">Clarification:</span>
            <p className="mt-1 text-sm text-gray-900">
              {truncateText(clarification.clarification_text, 200)}
            </p>
          </div>
          <div>
            Are you sure you want to delete this clarification?
          </div>
          <div>
            This action cannot be undone.
          </div>
        </div>
      )}
    </Modal>
  );
};
